import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SecurityDashboard = () => {
  const securityMetrics = [
    { label: 'Intentos de Login (24h)', value: '1,247', status: 'normal', icon: 'LogIn', color: 'text-blue-600' },
    { label: 'Sesiones Activas', value: '89', status: 'normal', icon: 'Users', color: 'text-green-600' },
    { label: 'Amenazas Bloqueadas', value: '12', status: 'warning', icon: 'ShieldAlert', color: 'text-orange-600' },
    { label: 'Auditorías Pendientes', value: '3', status: 'normal', icon: 'FileText', color: 'text-purple-600' }
  ];

  const recentSecurityEvents = [
    {
      id: 1,
      type: 'login_success',
      user: 'admin@3volcanes.com',
      action: 'Inicio de sesión exitoso',
      location: 'Arequipa, Perú',
      timestamp: '2026-01-20 18:30:15',
      severity: 'info'
    },
    {
      id: 2,
      type: 'failed_login',
      user: 'unknown@example.com',
      action: 'Intento de inicio de sesión fallido',
      location: 'Lima, Perú',
      timestamp: '2026-01-20 18:25:42',
      severity: 'warning'
    },
    {
      id: 3,
      type: 'api_access',
      user: 'system',
      action: 'Acceso a API de Facebook Graph',
      location: 'Server',
      timestamp: '2026-01-20 18:20:10',
      severity: 'info'
    },
    {
      id: 4,
      type: 'config_change',
      user: 'admin@3volcanes.com',
      action: 'Cambio en configuración de seguridad',
      location: 'Arequipa, Perú',
      timestamp: '2026-01-20 18:15:33',
      severity: 'info'
    },
    {
      id: 5,
      type: 'blocked_threat',
      user: 'firewall',
      action: 'Solicitud sospechosa bloqueada',
      location: 'Unknown',
      timestamp: '2026-01-20 18:10:05',
      severity: 'critical'
    }
  ];

  const getSeverityBadge = (severity) => {
    const badges = {
      info: 'bg-blue-100 text-blue-800',
      warning: 'bg-yellow-100 text-yellow-800',
      critical: 'bg-red-100 text-red-800'
    };
    return badges?.[severity] || 'bg-gray-100 text-gray-800';
  };

  const getSeverityIcon = (severity) => {
    const icons = {
      info: 'Info',
      warning: 'AlertTriangle',
      critical: 'AlertOctagon'
    };
    return icons?.[severity] || 'Info';
  };

  return (
    <div className="space-y-6">
      {/* Security Metrics */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {securityMetrics?.map((metric, index) => (
          <div key={index} className="card p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{metric?.label}</p>
                <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              </div>
              <Icon name={metric?.icon} size={32} className={metric?.color} />
            </div>
          </div>
        ))}
      </div>

      {/* Security Status */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-6">
          <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
            <Icon name="Shield" size={24} className="mr-2 text-primary" />
            Estado de Seguridad
          </h2>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <Icon name="CheckCircle" size={20} className="text-green-600" />
                <span className="text-sm font-medium text-foreground">Autenticación 2FA</span>
              </div>
              <span className="text-xs text-green-600 font-medium">Activo</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <Icon name="CheckCircle" size={20} className="text-green-600" />
                <span className="text-sm font-medium text-foreground">Cifrado SSL/TLS</span>
              </div>
              <span className="text-xs text-green-600 font-medium">Activo</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <Icon name="CheckCircle" size={20} className="text-green-600" />
                <span className="text-sm font-medium text-foreground">Firewall</span>
              </div>
              <span className="text-xs text-green-600 font-medium">Activo</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <Icon name="AlertTriangle" size={20} className="text-yellow-600" />
                <span className="text-sm font-medium text-foreground">Actualizaciones Pendientes</span>
              </div>
              <span className="text-xs text-yellow-600 font-medium">2 disponibles</span>
            </div>
          </div>
        </div>

        <div className="card p-6">
          <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
            <Icon name="Key" size={24} className="mr-2 text-primary" />
            Control de Acceso
          </h2>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 border border-border rounded-lg">
              <div>
                <p className="text-sm font-medium text-foreground">Administradores</p>
                <p className="text-xs text-muted-foreground">Acceso completo al sistema</p>
              </div>
              <span className="text-lg font-bold text-primary">3</span>
            </div>
            <div className="flex items-center justify-between p-3 border border-border rounded-lg">
              <div>
                <p className="text-sm font-medium text-foreground">Asesores</p>
                <p className="text-xs text-muted-foreground">Acceso a CRM y marketing</p>
              </div>
              <span className="text-lg font-bold text-primary">24</span>
            </div>
            <div className="flex items-center justify-between p-3 border border-border rounded-lg">
              <div>
                <p className="text-sm font-medium text-foreground">Usuarios</p>
                <p className="text-xs text-muted-foreground">Acceso limitado</p>
              </div>
              <span className="text-lg font-bold text-primary">156</span>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Security Events */}
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Icon name="Activity" size={24} className="mr-2 text-primary" />
            Eventos de Seguridad Recientes
          </h2>
          <Button variant="outline" size="sm" iconName="Download">
            Exportar Log
          </Button>
        </div>

        <div className="space-y-2">
          {recentSecurityEvents?.map((event) => (
            <div
              key={event?.id}
              className="flex items-start justify-between p-4 border border-border rounded-lg hover:bg-muted/50 transition-colors"
            >
              <div className="flex items-start space-x-3 flex-1">
                <Icon
                  name={getSeverityIcon(event?.severity)}
                  size={20}
                  className={event?.severity === 'critical' ? 'text-red-600' : event?.severity === 'warning' ? 'text-yellow-600' : 'text-blue-600'}
                />
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground">{event?.action}</p>
                  <div className="flex items-center space-x-4 mt-1">
                    <span className="text-xs text-muted-foreground flex items-center">
                      <Icon name="User" size={14} className="mr-1" />
                      {event?.user}
                    </span>
                    <span className="text-xs text-muted-foreground flex items-center">
                      <Icon name="MapPin" size={14} className="mr-1" />
                      {event?.location}
                    </span>
                    <span className="text-xs text-muted-foreground flex items-center">
                      <Icon name="Clock" size={14} className="mr-1" />
                      {event?.timestamp}
                    </span>
                  </div>
                </div>
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getSeverityBadge(event?.severity)}`}>
                {event?.severity === 'critical' ? 'Crítico' : event?.severity === 'warning' ? 'Advertencia' : 'Info'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecurityDashboard;
